import { useState } from "react";

//APP
import { esconderAccordion } from "../../meta";
import { useGetAgrupamentoTalhoes } from "../../../../../../services/monitoramento/agrupamentoTalhao/GET";
import { TypeDetailsMonitoramento } from "../../../../../../features/Monitoramento/Monitoramento.dataDetails";
import { MonitoramentoMapCalorType } from "../../../../novo-index";
import { MoniNivelItemControleItens } from "../../../../../../services/monitoramento/nivelControleItens";
import { mesclarCoordenadasDoAgrupamento, obterAgrupamentos, obterCoordenadasAgrupadas, obterCoordenadasMapDeCalor } from "./meta";

//COMPONENTS
import Carregando from "../../../../../CustomUi/loading";
import SvgAgrupados from "../../../../../CustomUi/talhaoSvgAgrupado";
import { Accordion } from "../../../../../CustomUi/accordion";
import { TabelaPraga } from "../../../tabelaPragas";

//PROPS
interface Props {
    main_data: { [key: string]: MonitoramentoMapCalorType[] };
    zoomNoMapaAgrupado: (coordenadas: { latitude: number, longitude: number }[]) => void;
    obterDadosAgrupamentoSelecionado: (dados_talhoes_agrupados: any) =>  { [x: number]: { [index: string]: any[]; }; }[];
    pragas_agrupamento_talhoes: any;
    listDates: any;
    nivelControle: MoniNivelItemControleItens[];
    handleAssembleHeatMap: Function;
    handleClickBadge: Function;
    setCalorSelect: Function;
    dataDetails: TypeDetailsMonitoramento;
    encolher: boolean;
    setVisibleDrawerPonto: React.Dispatch<React.SetStateAction<boolean>>;
    visibleChangeBooking: boolean;
    cod_propriedade: number;
}

export const Agrupamento: React.FC<Props> = ({ main_data, zoomNoMapaAgrupado, obterDadosAgrupamentoSelecionado, 
    pragas_agrupamento_talhoes, listDates, nivelControle, handleAssembleHeatMap, handleClickBadge, setCalorSelect, 
    dataDetails, encolher, setVisibleDrawerPonto, visibleChangeBooking, cod_propriedade
 }) => {

    //STATES
    const [open_accordion, setOpen_accordion] = useState<number>(null);
    
    //API
    const { data_agrupamentos, carregando_agrupamentos } = useGetAgrupamentoTalhoes(cod_propriedade);

    if (carregando_agrupamentos) {
        return (
            <div style={{height: 'calc(100vh - 320px)',display:'flex',alignContent:'center',justifyContent:'center'}}>
                <Carregando legenda="Processando dados do agrupamento..." animation justifyContent="center"/>
            </div>
        ) 
    }

    return (
        <div style={{ height: 'calc(100vh - 320px)', overflowY: 'auto', boxSizing: 'border-box', paddingRight: 7, marginTop: 10 }}>
            {(obterAgrupamentos(main_data, data_agrupamentos)).map(({ nome_agrupamento, cod_agrupamento, talhoes_agrupamento }, index, self)=> {
                return (
                    <Accordion
                        key={cod_agrupamento}
                        label={nome_agrupamento}
                        open={open_accordion === cod_agrupamento}
                        trigger={open_accordion === null
                            ? ()=> {
                                zoomNoMapaAgrupado(mesclarCoordenadasDoAgrupamento(talhoes_agrupamento));
                                obterDadosAgrupamentoSelecionado(talhoes_agrupamento?.map((i)=> i.monitoramento_talhao));
                                setOpen_accordion(cod_agrupamento);
                            }
                            : () => { setOpen_accordion(null) }
                        }
                        isFirst={index === 0}
                        isLast={(self.length - 1) === index}
                        single={self.length === 1}
                        style={{ display: esconderAccordion(open_accordion, cod_agrupamento) }}
                        extra={
                            <SvgAgrupados
                                fill={'#70CE9F'}
                                // @ts-ignore
                                coordinates={obterCoordenadasAgrupadas(talhoes_agrupamento)}
                            />
                        }
                    >
                        <TabelaPraga
                            nome_talhao={nome_agrupamento}
                            cod_talhao={0}
                            list_pragas={pragas_agrupamento_talhoes}
                            listDates={listDates}
                            nivelControle={nivelControle}
                            groupTotalizar={false}
                            handleAssembleHeatMap={handleAssembleHeatMap}
                            handleClickBadge={handleClickBadge}
                            setCalorSelect={setCalorSelect}
                            dataDetails={dataDetails}
                            encolher={encolher}
                            setVisibleDrawerPonto={setVisibleDrawerPonto}
                            visibleChangeBooking={visibleChangeBooking}
                            origem="Agrupamento"
                            coordenadas_agrupamento={obterCoordenadasMapDeCalor(talhoes_agrupamento)}
                            coord_talhoes_agrupamento={talhoes_agrupamento}
                        />
                    </Accordion>
                )
            })}
        </div>
    )
};